import { render, staticRenderFns } from "./BaseSelectSearch.vue?vue&type=template&id=a890e6d8&"
import script from "./BaseSelectSearch.vue?vue&type=script&lang=js&"
export * from "./BaseSelectSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports